import {Box, Overlay} from '@mantine/core';
import type {FC, ReactNode} from 'react';
import {MdLogin, MdPersonAdd, MdSchool} from 'react-icons/md';
import {COLOR_BLACK_2} from '../../config/constants/colorCodes';
import {LOGIN, PROFILE_AC_EMAIL} from '../../config/constants/routes';
import {getMailAuthLinkWithParamsHooks} from '../services/getMailAuthLinkWithParamsHooks';
import {CommonLink} from './CommonLink';

type Props = {
  children: ReactNode;
  title?: string;
  description?: string;
  studentVerificationDescription?: string;
  isStudentVerificationRequired?: boolean;
};

export const LoginPromptOverlay: FC<Props> = ({
  children,
  title = 'マイページ機能をご利用いただくには',
  description = 'お気に入り企業のフォローやイベントのクリップなど便利な機能をご利用いただけます。ぜひアカウントを作成してご活用ください。',
  studentVerificationDescription = 'マイページ機能のご利用には大学認証が必要です。',
  isStudentVerificationRequired = false,
}) => {
  const mailAuthLink = getMailAuthLinkWithParamsHooks({});

  return (
    <Box pos="relative">
      <Overlay blur={6} opacity={0.4} color={COLOR_BLACK_2} center zIndex={11}>
        <div className="flex flex-col bg-white rounded-16 w-3/4 pc:w-2/5 p-16 gap-8">
          <div className="flex flex-col text-center gap-8">
            <div className="text-black-1 font-bold">{title}</div>

            <div className="text-black-2 leading-relaxed text-sm">
              {isStudentVerificationRequired
                ? studentVerificationDescription
                : description}
            </div>
          </div>

          {isStudentVerificationRequired ? (
            <div className="flex pc:px-16 items-center justify-center">
              <CommonLink
                href={PROFILE_AC_EMAIL}
                className="w-full flex items-center justify-center font-bold bg-accent-1 text-white text-sm pc:text-base rounded-4 py-12 pc:py-16 hover:opacity-60"
              >
                <MdSchool className="mr-8" size={16} />
                大学認証を完了する
              </CommonLink>
            </div>
          ) : (
            <div className="flex flex-col pc:flex-row gap-8 pc:gap-16 pc:px-16 items-center justify-center">
              <CommonLink
                href={mailAuthLink}
                className="w-full flex items-center justify-center font-bold bg-accent-1 text-white text-sm pc:text-base rounded-4 py-12 pc:py-16 hover:opacity-60"
              >
                <MdPersonAdd className="mr-8" size={16} />
                新規会員登録（無料）
              </CommonLink>

              <CommonLink
                href={LOGIN}
                className="w-full flex items-center justify-center font-bold bg-white text-primary border border-primary text-sm pc:text-base rounded-4 py-12 pc:p-16 hover:opacity-60"
              >
                <MdLogin className="mr-8" size={16} />
                ログイン
              </CommonLink>
            </div>
          )}

          <div className="text-center hidden pc:block">
            <div className="text-black-3 text-xs">
              外資就活ドットコムの全ての機能をご利用いただけます
            </div>
          </div>
        </div>
      </Overlay>

      {/* 子要素（pointer-events-noneで操作無効化） */}
      <div className="pointer-events-none">{children}</div>
    </Box>
  );
};
